<template>
    <jet-dialog-modal 
        :show="modalOpen" 
        @close="$emit('close')"
        ref="modal"
    >
        <template #title>
            Create New List
        </template>

        <template #content>
            <form id="createGroupForm" @submit.prevent="submitHandler">
                <div class="tra__message-form flex flex-wrap relative">
                    <div class="w-full">
                        <label class="w-full block text-gray-700" for="title"
                            >List Name</label
                        >
                        <jet-input
                            v-model="form.title"
                            name="title"
                            placeholder="Title"
                            class="mb-3 w-full"
                            required
                        />
                        <jet-input-error
                            :message="$page.props.errors.title"
                            class="mt-2"
                        />
                    </div>
                    <div class="w-full">
                        <label
                            class="w-full block text-gray-700"
                            for="description"
                            >Description</label
                        >
                        <textarea
                            v-model="form.description"
                            name="description"
                            placeholder="A quick description of the list"
                            class="mb-3 w-full"
                        />
                        <jet-input-error
                            :message="$page.props.errors.description"
                            class="mt-2"
                        />
                    </div>
                </div>
            </form>
        </template>

        <template #footer>
            <button class="mr-4" @click="$emit('close')">
                Cancel
            </button>
            
            <jet-secondary-button
                type="submit"
                form="createGroupForm"
                :disabled="form.processing"
            >
                Create List
            </jet-secondary-button>
        </template>
    </jet-dialog-modal>
</template>

<script>
import JetDialogModal from "../Jetstream/DialogModal";
import JetSecondaryButton from "../Jetstream/SecondaryButton";

import {mapWritableState, mapActions} from 'pinia';
import { useGeneralTableStore } from '@/Stores/general_table';


export default {
    emits: ['close', 'group-created'],
    components: {
        JetDialogModal,
        JetSecondaryButton
    },
    name: "GroupCreateModal",
    props: {
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: this.$inertia.form({
                title: this.title,
                description: this.description
            })
        };
    },
    mounted() {
        console.log("group create modal mounted")
    },
    methods: {
        ...mapActions(useGeneralTableStore, [
            'fetchData',
        ]),
        submitHandler() {
            this.form.post(route("groups.create.submit.json"), {
                onSuccess: () => {
                    this.fetchData(); //refresh general table if in use
                    this.form.reset();
                    this.$toasted.success("List created", {
                        position: "bottom-right",
                        type: "success",
                        duration: 1000
                    });
                    this.$emit("group-created");
                    this.$emit('close');
                },
                onError: error => {
                    console.log(error);
                }
            });
        }
    },
    computed: {
        modalOpen() {
            return this.isOpen;
        }
    }
};
</script>

<style scoped></style>
